// extracted by mini-css-extract-plugin
export default {"page":"DecarbonizatorPage_page__O2XOL","container":"DecarbonizatorPage_container__fSU-u"};